/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfNameValueDto } from "../models/AjaxResponseOfNameValueDto";
import type { AuthCallbackRequest } from "../models/AuthCallbackRequest";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class FacebookAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public authorizeIntegradorSync({
    code,
    state,
  }: {
    code?: string;
    state?: string;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/facebook/authorize-integrador-sync",
      query: {
        code: code,
        state: state,
      },
    });
  }

  /**
   * @returns AjaxResponseOfNameValueDto
   * @throws ApiError
   */
  public isVendorAllowedToPost({
    id,
  }: {
    id?: string;
  }): CancelablePromise<AjaxResponseOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/facebook/is-vendor-allowed-to-post",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public insertFacebookToken({
    requestBody,
  }: {
    requestBody?: AuthCallbackRequest;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/facebook/token",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
